export async function useResumeAuth() {
  if (import.meta.client) {
    const route = useRoute();
    const authStore = useAuthStore();
    const fetchApi = useFetchApi();
    const localStorage = useLocalStorage();
    const sessionStorage = useSessionStorage();

    // Authentification --------------------------------------------------------------------------/
    const timestamp = Date.now();
    const access = sessionStorage.get("access");
    if (access?.token && (!access.exp || access.exp > timestamp)) {
      fetchApi.accessStore = access;
    } else {
      sessionStorage.remove("access");
    }

    const refresh = localStorage.get("refresh");
    if (refresh?.token && (!refresh.exp || refresh.exp > timestamp)) {
      fetchApi.refreshStore = refresh;
    } else {
      localStorage.remove("refresh");
    }

    if (fetchApi.accessStore.token) {
      await fetchApi.renew({ control: true }).catch(() => null);
    } else if (fetchApi.refreshStore.token) {
      await fetchApi.refresh({ control: true }).catch(() => null);
    }

    // Connected ---------------------------------------------------------------------------------/
    if (authStore.isConnected) {
      return useAuthRedirect();
    }

    // Not connected ---------------------------------------------------/
    authStore.reset();
    if (route.name === "authentification-chargement") {
      const redirect = sessionStorage.get("redirect");
      if (redirect) {
        const router = useRouter();
        const redirectRoute = router.resolve(redirect);
        sessionStorage.remove("redirect");
        return navigateTo(redirectRoute.fullPath);
      }

      return navigateTo("/authentification");
    }
  }
}
